import qs from 'qs'

import { wrapCall, callGet, callPost, callPut, callDelete } from './helpers'

//* ~~~~~~ NOTIFICATIONS ROUTES ~~~~~~

// Fetches notifications
export const fetchNotifications = async (
  unread_only: boolean,
  limit?: number,
  after?: string | null
) => {
  const query = qs.stringify(
    { unread_only, limit, after },
    { addQueryPrefix: true }
  )

  const {
    data,
    pagination: { next }
  } = (await wrapCall({
    method: callGet,
    uri: `/notifications${query}`,
    noData: true
  })) as WithTokenPagination<APINotification[]>

  return { data, next }
}

// Updates notification
export const updateNotification = async (
  id: string,
  data: { read: string }
) => {
  return (await wrapCall({
    method: callPut,
    uri: `/notifications/${id}`,
    data
  })) as APINotification
}

// Updates all notifications
export const markAllAsRead = async () => {
  return await wrapCall({ method: callDelete, uri: `/notifications` })
}

//* ~~~~~~ BROWSER PUSH NOTIFICATIONS ~~~~~~

// Registering this browser for push notifications
export const subscribePush = async data => {
  return await wrapCall({
    method: callPost,
    uri: '/subscriptions/web/register',
    data
  })
}

// De-register this endpoint
export const unsubscribePush = async data => {
  return await wrapCall({
    method: callPost,
    uri: '/subscriptions/web/unregister',
    data: { endpoint: data.endpoint }
  })
}
